export const environment = {
  production: false,
  baseUrl: 'https://api.atramehr.ir',
};
